import { Injectable } from '@angular/core';
import { ColorPipe } from './color.pipe';

@Injectable({
  providedIn: 'root',
})
export class StyleService {
  constructor(private colorPipe: ColorPipe) {}

  addTransparency(hex: string): string {
    if (!hex.includes('#')) {
      return hex;
    }

    const _hex = this.colorPipe.transform(hex);
    return `${_hex}99`;
  }

  adjustColor(hex: string, percent: number): string {
    if (!hex.includes('#')) {
      return hex;
    }

    const _hex = hex.replace(/^#/, '');

    let r = parseInt(_hex.substring(0, 2), 16);
    let g = parseInt(_hex.substring(2, 4), 16);
    let b = parseInt(_hex.substring(4, 6), 16);

    const amount = Math.floor((255 * Math.abs(percent)) / 100);

    if (percent > 0) {
      r = Math.max(0, r - amount);
      g = Math.max(0, g - amount);
      b = Math.max(0, b - amount);
    } else {
      r = Math.min(255, r + amount);
      g = Math.min(255, g + amount);
      b = Math.min(255, b + amount);
    }

    const newHex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);

    return `#${newHex}`;
  }
}
